module.exports = __webpack_public_path__ + "media/images/riders/small/REMI_THIRION-b65577f01a09895740cd988e5391f437.png";